<template>
     <div id='menu' class='menu-popup hidden'  @mouseenter="cancelHide"  @mouseleave="hideMenu" v-if='selected_heading.sub_headings'  v-show='selected_heading.sub_headings.length != 0'>
        <div class='menu-popup-container'>
            <div v-for='sub_heading in selected_heading.sub_headings' :key='sub_heading.id' class='column'>
                <a class='sub-heading' :href="(sub_heading.type == 'CU') ? sub_heading.custom_url : `/${sub_heading.sef_url}`" @click='selectedMenuItem($event,sub_heading)'>{{sub_heading.name}}</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['selected_heading'],
    emits: ['selectedMenuItemListener', 'cancelHideListener', 'hideMenuListener'],
    methods:{
        selectedMenuItem(event, category){
            this.$emit('selectedMenuItemListener', event, category);
        },
        cancelHide() {
            this.$emit('cancelHideListener');
        },
        hideMenu() {
            this.$emit('hideMenuListener');
        }
    }
}
</script>

<style lang="scss" scoped>

.menu-popup{
    position: absolute;
    // width: 1200px;
    width: 100%;
    height: 100%;
    // left: 200px;
    margin-top: var(--desktop-menu-container-height);
    top: 0;
    border-radius: 5px;
    // border: solid #e9ecef 2px;
    background-color: var(--top-nav-bar-background-colour);
    padding: 20px 10px;
    // overflow-y:auto; 
    // overflow-x:hidden; 
    // scrollbar-width: thin; //Firefox only
    // scrollbar-color: darkgrey white; //Firefox only
    overflow: hidden;
    // padding-left: 400px;
}
.menu-popup-container{
    // display: flex;
}
.sub-categories-container{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 50px 0px;
    align-items: flex-start;
    // flex: 2;
    width: 100%;
}
.promo-section{
    flex: 1;
    padding-right: 150px;
}
.column{
    // flex-basis: 17%;
    // display: flex;
    flex-direction: column;
    gap: 24px;
    // border-right: solid #e9ecef 1px;
    padding-left: 20px;
}
.sub-heading{
    font-size: 0.9rem;
    font-weight: 400;
    margin-bottom: 5px;
    cursor: pointer;
    // text-transform: uppercase;
    text-decoration: none;
    color: white;
    width: 100%;

    &:hover{
        text-decoration: underline;
    }
}

.menu-item{
    font-size: 0.85rem;
    cursor: pointer;
    color: #495057;
    text-decoration: none;
}

.menu-popup::-webkit-scrollbar { //Chrome, Edge, and Safari 
  width: 0.5rem;
}
 
.menu-popup::-webkit-scrollbar-track{ //Chrome, Edge, and Safari 
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
}
 
.menu-popup::-webkit-scrollbar-thumb { //Chrome, Edge, and Safari 
  background-color: darkgrey;
  border-radius: 10px;
}

.menu-popup.hidden{
    display:none;
}

</style>